<script lang="ts" setup>
  import { storeToRefs } from 'pinia';
  import { onBeforeMount, onMounted, watch } from 'vue';

  import BasicLayout from '@/layout/main/BasicLayout.vue';
  import { landing as landingRoutes } from '@/router/landing.routes.enum';
  import { useAuthStore } from '@/stores/auth.store';
  import { useLocaleStore } from '@/stores/locale.store';
  import { useOrganizationStore } from '@/stores/organzation.pinia';
  import { usePermissionsStore } from '@/stores/permissoins.store';
  import NotFound from '@/views/misc/NotFound.vue';

  import SnackbarVue from './components/misc/snackbar.vue';
  import { useNotificationsStore } from './stores/notifications.store';

  const { isLTR } = storeToRefs(useLocaleStore());

  const authStore = useAuthStore();
  const { getOrganizationDynamicPages } = useOrganizationStore();
  // Same rule the router uses to gate /pages/:slug — one source of truth.
  const getDynamicPage = () => {
    if (
      usePermissionsStore().checkAuthentication(landingRoutes.usefulLink.meta)
    )
      return getOrganizationDynamicPages();
  };
  onBeforeMount(async () => {
    await Promise.all([
      //if there other stores or functions to initialize, add them here
      authStore.initializeAuth(),
      getDynamicPage(),
    ]);
  });
  const assignFontFamily = () => {
    const overlayContainer = document.querySelector('body');

    if (overlayContainer) {
      if (isLTR.value) {
        overlayContainer.classList.remove('ar');
        overlayContainer.classList.add('en');
      } else {
        overlayContainer.classList.remove('en');
        overlayContainer.classList.add('ar');
      }
    }
  };
  onMounted(() => {
    assignFontFamily();
  });
  watch(
    () => isLTR.value,
    () => {
      assignFontFamily();
      if (authStore.user?.id && authStore.user?.isVerified !== false)
        useNotificationsStore().getNotifications();
    }
  );
  const organizationStore = useOrganizationStore();
  const { organizationNotFound } = storeToRefs(organizationStore);
</script>

<template>
  <v-app class="bg-app">
    <NotFound v-if="organizationNotFound" no-redirect />
    <template v-else>
      <BasicLayout></BasicLayout>
      <SnackbarVue />
    </template>
  </v-app>
</template>
